










































































































import User from '@/models/User'
import {apiV1AdminUserPath} from '@/rails/routes'
import axios from 'axios'
import { Component, Emit, Prop } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import { DataTableHeader } from 'vuetify'
import ListCount from '@/components/admin/ListCount.vue'
import UserListCondition from '@/models/shared/UserListCondition'

@Component({
  components: {
    ListCount
  }
})
export default class UserList extends VueBase {
  @Prop(Boolean) readonly readonly!: boolean
  @Prop(Boolean) readonly selector!: boolean
  @Prop(Array) readonly users!: Array<User>
  @Prop({ type: Array, default: () => [] }) readonly value!: Array<number>
  @Prop({ type: Object, default: () => new UserListCondition() }) condition!: UserListCondition
  @Prop({ type: Array, default: () => {
      return []
    }}) readonly additionalHeaders: Array<DataTableHeader>

  showedEditMemo = false
  headers: Array<DataTableHeader> = [
    { text: '', value: 'actions', sortable: false, width: this.readonly ? 1 : 100, class: 'px-2' },
    { text: 'ID', value: 'id', width: 50, class: 'px-2' },
    { text: 'Email', value: 'email', width: 200 ,class: 'px-2' },
    { text: '氏名', value: 'name', width: 120, class: 'px-2' },
    { text: '年齢', value: 'birthday', width: 60, class: 'px-2' },
    { text: '居住地', value: 'address', width: 160, class: 'px-2' },
    { text: '登録状態', value: 'active', width: 100, class: 'px-2' },
    { text: 'ステータス', value: 'progress_status', width: 110, class: 'px-2' },
    { text: 'メモ', value: 'progress_status_memo', width: 240, class: 'px-2' },
    { text: 'メルマガ配信', value: 'receive_e_zine', width: 70, class: 'px-2' },
    { text: '登録日時', value: 'created_at', width: 180, class: 'px-2' },
    { text: '最終アクセス日時', value: 'current_sign_in_at', width: 180, class: 'px-2' }
  ]
  progress_statuses = [
    { text: '確定', value: 'fix' },
    { text: '内定', value: 'offer' },
    { text: 'A', value: 'a' },
    { text: 'B', value: 'b' },
    { text: 'C', value: 'c' },
    { text: 'D', value: 'd' },
    { text: 'OB', value: 'ob' },
    { text: 'Z', value: 'z' },
    { text: '関係者', value: 'staff' }
  ]
  statuses = [
    { text: '仮登録のみ', value: 0 },
    { text: '本登録済のみ', value: 1 },
    { text: '仮登録 + 本登録済', value: 2 },
    { text: '退会済', value: -1 }
  ]
  edit = new User()
  editMemo = null
  debounceReloadTimer = 0

  @Emit()
  input(value: Array<number>): Array<number> {
    return value
  }

  @Emit()
  onReload(): void {}

  @Emit()
  onDownload(): void {}

  get internalValue(): Array<number> {
    return this.value
  }

  set internalValue(val: Array<number>) {
    if (val.length > 1) {
      val.shift()
    }
    this.input(val)
  }

  mounted(): void {}

  debounceReload(resetPage = true): void {
    // sort-byを変更すると、sort-by、sort-descの2つが同時にイベントが走ることがあるので
    // 一定時間内のイベントは1回にまとめる
    clearTimeout(this.debounceReloadTimer)
    if (resetPage) {
      this.condition.page = 1
    }
    this.debounceReloadTimer = setTimeout(() => {
      this.onReload()
    }, 300)
  }

  startEditMemo(user: User): void {
    this.edit = user
    this.editMemo = user.progress_status_memo
    this.showedEditMemo = true
  }

  saveMemo(): void {
    this.edit.progress_status_memo = this.editMemo
    this.editMemo = null
    this.save(this.edit)
    this.showedEditMemo = false
  }

  async save(user: User): Promise<void> {
    try {
      await axios.put(apiV1AdminUserPath(user.id), {
        user: user.toParamsBaseItem()
      })
      this.showMessage('変更を保存しました。')
    } catch (e) {
      console.log(e)
    }
  }
}
